module.exports = __webpack_public_path__ + "img/freewave2_01.f3e21faa.jpg";